import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  input: {
    margin: [theme.spacing(3), 0],
  },
  button: {
    borderRadius: 4,
    fontWeight: 'normal',
    height: 40,
    backgroundColor: theme.palette.colors.lightTeal,
    color: theme.palette.colors.teal,
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(1),
    fontSize: 13,
    [theme.breakpoints.up('mobile')]: {
      fontSize: 16,
    },
  },
  suggested: {
    backgroundColor: theme.palette.colors.lightGreen,
    color: theme.palette.colors.white,
  },
  stretched: {
    backgroundColor: theme.palette.colors.amber,
    color: theme.palette.colors.white,
  },
  aggressive: {
    backgroundColor: theme.palette.colors.red,
    color: theme.palette.colors.white,
  },
  hoverSuggested: {
    '&:hover': {
      backgroundColor: theme.palette.colors.lightGreen,
      color: theme.palette.colors.white,
    },
  },
  hoverStretched: {
    '&:hover': {
      backgroundColor: theme.palette.colors.amber,
      color: theme.palette.colors.white,
    },
  },
  hoverAggressive: {
    '&:hover': {
      backgroundColor: theme.palette.colors.red,
      color: theme.palette.colors.white,
    },
  },
  controlBar: {
    display: 'flex',
    marginTop: theme.spacing(2),
    flexWrap: 'wrap',
    justifyContent: 'start',
    maxWidth: '400px',
  },
  calculationsBar: {
    width: '100%',
    display: 'flex',
    marginBottom: theme.spacing(4),
    flexWrap: 'wrap',
  },
  calculationsItem: {
    width: '50%',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: 'unset',
      width: '33%',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/SavingsMinimumQuestion/useStyles.js